export enum CaseOptions {
  SelectAll = 'Select all',
  ActivateAll = 'Activate all',
  DeactivateAll = 'Deactivate all',
  Download = 'Download',
  CopyAssets = 'Copy assets',
  RemoveBatch = 'Remove batch',
}
